import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AnnouncementInfo } from '../../services/announcement.service';
import { AccountService } from '../../pages/account/account.service';

@Injectable({ providedIn: 'root' })
export class AnnouncementsBannerService {
  private _accountService = inject(AccountService);
  private _announcements$ = new BehaviorSubject<AnnouncementInfo[]>([]);

  readonly announcements$: Observable<AnnouncementInfo[]> = this._announcements$.asObservable();

  load(): void {
    this._accountService.getAnnouncements().subscribe((announcements) => {
      this._announcements$.next(announcements ?? []);
    });
  }
}
